import controller from './account-menu.controller';
import template from './account-menu.html';

export default {
	controller,
	controllerAs: '$ctrl',
	template,
};
